"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MathUnit = void 0;

var _types = require("../formulas/types");

var _math = require("../formulas/math");

var _units = require("./units");

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MATH_UNIT_OPTIONS = _units.UNIT_TYPES_LIST.map(function (ut) {
  return {
    label: ut.label,
    value: ut.mathValue
  };
}).filter(function (u) {
  return !!u.value;
});

var HYDRATED_WITH_MATH_UNITS_LIST = MATH_UNIT_OPTIONS.map(function (unitOption) {
  return _objectSpread(_objectSpread({}, unitOption), {}, {
    mathUnit: _math.math.unit(unitOption.value)
  });
}); // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

var CURRENCY_UNITS = [_math.math.Unit.UNITS.USD, _math.math.Unit.UNITS.EURO];

var MathUnit = /*#__PURE__*/function () {
  function MathUnit() {
    _classCallCheck(this, MathUnit);
  }

  _createClass(MathUnit, null, [{
    key: "getLabel",
    value: function getLabel(mathUnitName) {
      var selectableUnit = this.selectableList.find(function (su) {
        return su.value === mathUnitName;
      });
      return (selectableUnit === null || selectableUnit === void 0 ? void 0 : selectableUnit.label) || mathUnitName;
    }
  }, {
    key: "isValid",
    value: function isValid(unitName) {
      try {
        _math.math.unit(1, unitName);

        return true;
      } catch (_unused) {
        return false;
      }
    }
  }, {
    key: "isCurrency",
    value: function isCurrency(unit) {
      return CURRENCY_UNITS.map(function (cu) {
        return cu === null || cu === void 0 ? void 0 : cu.name;
      }).includes(unit);
    } // A unit can have several aliases, e.g. meter, meters, m,
    // therefor we can't compare unit names for simple string equality.

  }, {
    key: "areEqual",
    value: function areEqual(u1, u2) {
      if (u1 === u2 || !u1 && !u2) return true;
      if (u1 && !u2 || !u1 && u2) return false; // If no value is provided, mathJS returns TRUE!
      // math.unit('m').equals(math.unit('ft') returns true 🤦
      // work around this by using equal magnitude (1)

      var mathUnit1 = _math.math.unit(1, u1);

      var mathUnit2 = _math.math.unit(1, u2);

      return mathUnit1.equals(mathUnit2);
    }
  }, {
    key: "areRelated",
    value: function areRelated(u1, u2) {
      if (u1 === u2 || !u1 && !u2) return true;
      if (u1 && !u2 || !u1 && u2) return false;

      var mathUnit1 = _math.math.unit(u1);

      var mathUnit2 = _math.math.unit(u2);

      return mathUnit1.equalBase(mathUnit2);
    }
  }, {
    key: "getRelatedSelectableUnits",
    value: function getRelatedSelectableUnits(unitName) {
      var _this = this;

      var doesListIncludeInputUnit = false;
      var relatedUnits = [];

      var mathUnit = _math.math.unit(unitName);

      HYDRATED_WITH_MATH_UNITS_LIST.forEach(function (hydrated) {
        if (!mathUnit.equalBase(hydrated.mathUnit)) return;

        var mu = hydrated.mathUnit,
            rest = _objectWithoutProperties(hydrated, ["mathUnit"]);

        relatedUnits.push(rest);
        if (_this.areEqual(unitName, hydrated.value)) doesListIncludeInputUnit = true;
      });

      if (!doesListIncludeInputUnit) {
        // add in the `unitName` units if it wasn't covered in `HYDRATED_WITH_MATH_UNITS_LIST`
        relatedUnits.push({
          label: unitName,
          value: unitName
        });
      }

      return relatedUnits;
    }
  }, {
    key: "convert",
    value: function convert(fromValue, toUnit) {
      var mathUnit = (0, _types.isUnitAwareNumber)(fromValue) ? _math.math.unit(fromValue.value, fromValue.unit) : // m / m just because it becomes unitless in the end. Could be any unit divided by itself though
      _math.math.unit(fromValue, 'm / m'); // An example of error if units can't be converted: "Units do not match ('lbs' != '3 meters')"

      var converted = mathUnit.to(toUnit);

      var _converted$toJSON = converted.toJSON(),
          newUnit = _converted$toJSON.unit,
          newValue = _converted$toJSON.value;

      return {
        unit: newUnit,
        value: newValue
      };
    }
  }, {
    key: "toStorage",
    value: function toStorage(_ref) {
      var unit = _ref.unit,
          value = _ref.value;
      var mathUnit = this.toBaseMathUnit(_math.math.unit(value, unit));
      var mathJSON = mathUnit.toJSON();
      return {
        unit: mathJSON.unit,
        value: mathJSON.value
      };
    }
  }, {
    key: "fromStorage",
    value: function fromStorage(storageValue, targetUnit) {
      if (storageValue == null) return null;
      if (!targetUnit) return storageValue;
      var storageUnit = this.getStorageUnitForUnit(targetUnit);
      return storageUnit === '' ? this.convert(storageValue, targetUnit).value : this.convert({
        unit: storageUnit,
        value: storageValue
      }, targetUnit).value;
    }
  }, {
    key: "getStorageUnitForUnit",
    value: function getStorageUnitForUnit(unit) {
      return this.toStorage({
        unit: unit,
        value: 1
      }).unit;
    }
    /*
      Each mathjs Unit consist of one or more UnitComponents,
      e.g. "ft" consist of just one UnitComponent – "ft", "lbs/gal" consist of two – "lbs" and "gallons".
       Each UnitComponent can be expressed through one of the base dimensions,
      e.g. square feet UnitComponent technically belongs to SURFACE dimension:
        {
          unit: { name: 'ft2', base: [0, 2, 0, 0, ...] },
          power: 1,
        }
      but it can be expressed through base LENGTH dimension:
        {
          unit: { name: 'meter', base: [0, 1, 0, 0, ...] },
          power: 2,
        }
       This method replaces UnitComponents of mathjs Unit with the ones that are expressed
      through base dimension. This essentially converts each Unit's part into storage unit.
       Implementation inspired how mathjs's Unit.toSI() and Unit.to() methods.
     */

  }, {
    key: "toBaseMathUnit",
    value: function toBaseMathUnit(givenUnit) {
      var unit = givenUnit.clone();
      var proposedUnitList = [];

      _math.math.Unit.BASE_DIMENSIONS.forEach(function (baseDim, idx) {
        if (Math.abs(unit.dimensions[idx] || 0) > 1e-12) {
          var baseUnitConfig = _math.baseUnitConfigs[baseDim];
          proposedUnitList.push({
            unit: baseUnitConfig.unit,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error mathjs type is invalid, prefix of UnitComponent is not a string, but UnitPrefix type
            prefix: baseUnitConfig.prefix,
            power: unit.dimensions[idx] || 0
          });
        }
      });
      /*
        Need to adjust value by difference in offset,
        but only if given unit is a simple unit.
        For example, 1 F = -17.2 C because C = (F - 32) * 5/9
        but 1 kg/F = 5/9 kg/C because we care only about
        how many Celsius degrees is in one Fahrenheit degree, not how one scale match to another.
      */


      if (unit.value != null && unit.units.length === 1 && unit.units[0] && unit.units[0].unit.offset && proposedUnitList[0]) {
        var _unit$units$0$unit = unit.units[0].unit,
            givenUnitValue = _unit$units$0$unit.value,
            givenUnitNominalOffset = _unit$units$0$unit.offset;
        var givenUnitOffset = givenUnitValue * givenUnitNominalOffset;
        var _proposedUnitList$0$u = proposedUnitList[0].unit,
            baseUnitValue = _proposedUnitList$0$u.value,
            baseUnitNominalOffset = _proposedUnitList$0$u.offset;
        var baseUnitOffset = baseUnitValue * baseUnitNominalOffset;
        unit.value = unit.value + givenUnitOffset - baseUnitOffset;
      }

      unit.units = proposedUnitList;
      unit.fixPrefix = true;
      unit.skipAutomaticSimplification = true;
      return unit;
    }
  }, {
    key: "round",
    value: function round(value) {
      var digitsOfPrecision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 7;
      return Number(value === null || value === void 0 ? void 0 : value.toPrecision(digitsOfPrecision));
    }
  }]);

  return MathUnit;
}();

exports.MathUnit = MathUnit;

_defineProperty(MathUnit, "selectableList", MATH_UNIT_OPTIONS);